import React, { memo } from 'react';
import PropTypes from 'prop-types';
import DateWidget from '../date-widget';
import { PriorityIcon } from '@utils/icon-utils';
import { calculateDays } from '@utils/timeline-chart-utils';
import './triptych-widget.scss';

const TriptychWidget = ({
  displayDuration,
  end,
  name,
  priority,
  start,
  style = { padding: '0 0 0.75rem 0' }
}) => {
  const renderDuration = () => {
    const duration = calculateDays(start, end);
    return `${duration} ${duration === 1 ? 'day' : 'days'}`;
  };

  return (
    <div styleName="triptych-widget-container" style={style}>
      <DateWidget start={start} end={end} />
      {!priority && <div styleName="bull">&bull;</div>}
      {priority && <div styleName="bull-left">&bull;</div>}
      {priority && <PriorityIcon priority={priority} />}
      {priority && <div styleName="bull-right">&bull;</div>}
      {displayDuration && renderDuration()}
      {name}
    </div>
  );
};

TriptychWidget.propTypes = {
  displayDuration: PropTypes.bool,
  end: PropTypes.string,
  name: PropTypes.string,
  priority: PropTypes.number,
  start: PropTypes.string,
  style: PropTypes.object
};

export default memo(TriptychWidget);
